import React from "react";
import PDFViewer from "../Post/PDFViewer";

const EpaperView = ({ url }) => {
  return (
    <div className="cv-render">
      <PDFViewer height="800px" pdf={url} />
    </div>
  );
};

export default EpaperView;
